import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { merge, Subscription } from "rxjs";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { ValidatorsError } from "src/model/enum/enumFormValidators";

/**
 * Handle form validators for IP
 */
export class PasswordValidators {
  /**This validator checks if the IP is correct */
  static isPWDCorret(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let validationError = null;

      if (!new RegExp(AppSettings.PATTERN_PWD).test(control.value)) {
        validationError = {};
        validationError[ValidatorsError.PWD_INVALID] = true;
        return validationError;
      }
      return validationError;
    };
  }

  /**
   * Keep the "mismatch" error of the confirmation field in step with the password, while the user
   * types in either of them: the form stays invalid (and the message under the field visible)
   * until the two passwords are the same.
   *
   * @param form form group with the two fields
   * @param passwordKey name of the password field
   * @param confirmKey name of the confirmation field
   * @returns the subscription, to unsubscribe when the form is destroyed
   */
  static watchPasswordMatch(form: AbstractControl, passwordKey: string = "password", confirmKey: string = "confirmPassword"): Subscription {
    const password = form.get(passwordKey);
    const confirm = form.get(confirmKey);

    return merge(password.valueChanges, confirm.valueChanges).subscribe(() => {
      const errors = { ...(confirm.errors ?? {}) };
      delete errors["mismatch"];
      if (confirm.value && confirm.value !== password.value) {
        errors["mismatch"] = true;
      }
      confirm.setErrors(Object.keys(errors).length > 0 ? errors : null);
    });
  }
}
